import { Stack, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import DashboardTable from "../../../components/Dashboard/DashboardTable";
import Template from "../../../components/Dashboard/Template";
import TableData from "../../../dumyData/company/CompanyJobRequest.json";
import { formattedDate } from "../../../utils";
import { t } from "i18next";

const diplayRows = [
  "date_and_month",
  "worker_upcomming_job_detail",
  "worker_upcomming_job_price",
];

const TodaysJobs = ({ allJobs, isLoading }) => {
  const { palette } = useTheme();
  const [todayDate, setTodayDate] = useState(formattedDate(new Date(), false));

  return (
    <Template
      primaryHeading={t("todaysJobActivity")}
      secondaryHeading={t("viewTodaysJob")}
    >
      {allJobs?.length == 0 && isLoading?.states === false ? (
        <Stack height={"100%"} alignItems={"center"} justifyContent={"center"}>
          <Typography variant="h5" fontWeight={600}>
            {t("noTodaysJobsFound")}!
          </Typography>
        </Stack>
      ) : (
        <DashboardTable
          showHeader={false}
          tableData={allJobs}
          diplayRows={diplayRows}
        />
      )}
    </Template>
  );
};

export default TodaysJobs;
